import { render, staticRenderFns } from "./Warrantys.vue?vue&type=template&id=cbb3a7c4&scoped=true&"
import script from "./Warrantys.vue?vue&type=script&lang=js&"
export * from "./Warrantys.vue?vue&type=script&lang=js&"
import style0 from "./Warrantys.vue?vue&type=style&index=0&id=cbb3a7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb3a7c4",
  null
  
)

export default component.exports